export const LINK_HOME = `/`
export const LINK_404 = `/404`
export const LINK_THANK_YOU = `/thank-you`
export const LINK_TERMS_OF_USE = `/terms-of-use`
export const LINK_PRIVACY_POLICY = `/privacy-policy`